import { CategoryIconMapping } from '@src/federations/shared/categoryIcons/CategoryIconsService';

export const isoCode2ToIsoCode: Record<string, string> = {
    AD: 'AND',
    AE: 'ARE',
    AF: 'AFG',
    AG: 'ATG',
    AI: 'AIA',
    AL: 'ALB',
    AM: 'ARM',
    AO: 'AGO',
    AR: 'ARG',
    AS: 'ASM',
    AT: 'AUT',
    AU: 'AUS',
    AW: 'ABW',
    AX: 'ALA',
    AZ: 'AZE',
    BA: 'BIH',
    BB: 'BRB',
    BD: 'BGD',
    BE: 'BEL',
    BF: 'BFA',
    BG: 'BGR',
    BH: 'BHR',
    BI: 'BDI',
    BJ: 'BEN',
    BL: 'BLM',
    BM: 'BMU',
    BN: 'BRN',
    BO: 'BOL',
    BQ: 'BES',
    BR: 'BRA',
    BS: 'BHS',
    BT: 'BTN',
    BW: 'BWA',
    BY: 'BLR',
    BZ: 'BLZ',
    CA: 'CAN',
    CC: 'CCK',
    CD: 'COD',
    CF: 'CAF',
    CG: 'COG',
    CH: 'CHE',
    CI: 'CIV',
    CK: 'COK',
    CL: 'CHL',
    CM: 'CMR',
    CN: 'CHN',
    CO: 'COL',
    CR: 'CRI',
    CU: 'CUB',
    CV: 'CPV',
    CW: 'CUW',
    CX: 'CXR',
    CY: 'CYP',
    CZ: 'CZE',
    DE: 'DEU',
    DJ: 'DJI',
    DK: 'DNK',
    DM: 'DMA',
    DO: 'DOM',
    DZ: 'DZA',
    EC: 'ECU',
    EE: 'EST',
    EG: 'EGY',
    EH: 'ESH',
    EN: 'ENG',
    ER: 'ERI',
    ES: 'ESP',
    ET: 'ETH',
    FI: 'FIN',
    FJ: 'FJI',
    FK: 'FLK',
    FM: 'FSM',
    FO: 'FRO',
    FR: 'FRA',
    GA: 'GAB',
    GB: 'GBR',
    GD: 'GRD',
    GE: 'GEO',
    GF: 'GUF',
    GG: 'GGY',
    GH: 'GHA',
    GI: 'GIB',
    GL: 'GRL',
    GM: 'GMB',
    GN: 'GIN',
    GP: 'GLP',
    GQ: 'GNQ',
    GR: 'GRC',
    GT: 'GTM',
    GU: 'GUM',
    GW: 'GNB',
    GY: 'GUY',
    HK: 'HKG',
    HN: 'HND',
    HR: 'HRV',
    HT: 'HTI',
    HU: 'HUN',
    ID: 'IDN',
    IE: 'IRL',
    IL: 'ISR',
    IM: 'IMN',
    IN: 'IND',
    IO: 'IOT',
    IQ: 'IRQ',
    IR: 'IRN',
    IS: 'ISL',
    IT: 'ITA',
    JE: 'JEY',
    JM: 'JAM',
    JO: 'JOR',
    JP: 'JPN',
    KE: 'KEN',
    KG: 'KGZ',
    KH: 'KHM',
    KI: 'KIR',
    KM: 'COM',
    KN: 'KNA',
    KP: 'PRK',
    KR: 'KOR',
    KW: 'KWT',
    KY: 'CYM',
    KZ: 'KAZ',
    LA: 'LAO',
    LB: 'LBN',
    LC: 'LCA',
    LI: 'LIE',
    LK: 'LKA',
    LR: 'LBR',
    LS: 'LSO',
    LT: 'LTU',
    LU: 'LUX',
    LV: 'LVA',
    LY: 'LBY',
    MA: 'MAR',
    MC: 'MCO',
    MD: 'MDA',
    ME: 'MNE',
    MF: 'MAF',
    MG: 'MDG',
    MH: 'MHL',
    MK: 'MKD',
    ML: 'MLI',
    MM: 'MMR',
    MN: 'MNG',
    MO: 'MAC',
    MP: 'MNP',
    MQ: 'MTQ',
    MR: 'MRT',
    MS: 'MSR',
    MT: 'MLT',
    MU: 'MUS',
    MV: 'MDV',
    MW: 'MWI',
    MX: 'MEX',
    MY: 'MYS',
    MZ: 'MOZ',
    NA: 'NAM',
    NC: 'NCL',
    NE: 'NER',
    NF: 'NFK',
    NG: 'NGA',
    NI: 'NIC',
    NL: 'NLD',
    NO: 'NOR',
    NP: 'NPL',
    NR: 'NRU',
    NU: 'NIU',
    NZ: 'NZL',
    OM: 'OMN',
    PA: 'PAN',
    PE: 'PER',
    PF: 'PYF',
    PG: 'PNG',
    PH: 'PHL',
    PK: 'PAK',
    PL: 'POL',
    PM: 'SPM',
    PR: 'PRI',
    PS: 'PSE',
    PT: 'PRT',
    PW: 'PLW',
    PY: 'PRY',
    QA: 'QAT',
    RE: 'REU',
    RO: 'ROU',
    RS: 'SRB',
    RU: 'RUS',
    RW: 'RWA',
    SA: 'SAU',
    SB: 'SLB',
    SC: 'SYC',
    SD: 'SDN',
    SE: 'SWE',
    SG: 'SGP',
    SH: 'SHN',
    SI: 'SVN',
    SJ: 'SJM',
    SK: 'SVK',
    SL: 'SLE',
    SM: 'SMR',
    SN: 'SEN',
    SO: 'SOM',
    SR: 'SUR',
    SS: 'SSD',
    ST: 'STP',
    SV: 'SLV',
    SX: 'SXM',
    SY: 'SYR',
    SZ: 'SWZ',
    TC: 'TCA',
    TD: 'TCD',
    TG: 'TGO',
    TH: 'THA',
    TJ: 'TJK',
    TK: 'TKL',
    TL: 'TLS',
    TM: 'TKM',
    TN: 'TUN',
    TO: 'TON',
    TR: 'TUR',
    TT: 'TTO',
    TV: 'TUV',
    TW: 'TWN',
    TZ: 'TZA',
    UA: 'UKR',
    UG: 'UGA',
    US: 'USA',
    UY: 'URY',
    UZ: 'UZB',
    VA: 'VAT',
    VC: 'VCT',
    VE: 'VEN',
    VG: 'VGB',
    VI: 'VIR',
    VN: 'VNM',
    VO: 'VOI',
    VU: 'VUT',
    WF: 'WLF',
    WS: 'WSM',
    YE: 'YEM',
    YT: 'MYT',
    ZA: 'ZAF',
    ZM: 'ZMB',
    ZN: 'ZNZ',
    ZW: 'ZWE',
};

// Snapshot taken at 2024-10-23
export const defaultFlagDefinitions: CategoryIconMapping[] = [
    {
        categoryIds: [793],
        iconKey: 'AFG',
    },
    {
        categoryIds: [376],
        iconKey: 'AGO',
    },
    {
        categoryIds: [],
        iconKey: 'AIA',
    },
    {
        categoryIds: [510, 839],
        iconKey: 'ATG',
    },
    {
        categoryIds: [811, 1319],
        iconKey: 'ABW',
    },
    {
        categoryIds: [3],
        iconKey: 'ATP',
    },
    {
        categoryIds: [322, 54, 923, 1267],
        iconKey: 'ZAF',
    },
    {
        categoryIds: [16, 665, 784],
        iconKey: 'ALB',
    },
    {
        categoryIds: [221, 683, 797, 804],
        iconKey: 'DZA',
    },
    {
        categoryIds: [218],
        iconKey: 'AND',
    },
    {
        categoryIds: [45, 126, 125, 6, 207, 366, 370, 1332, 1591],
        iconKey: 'ENG',
    },
    {
        categoryIds: [592, 47, 798, 842],
        iconKey: 'SAU',
    },
    {
        categoryIds: [110, 183, 455, 894, 771],
        iconKey: 'ARG',
    },
    {
        categoryIds: [267, 887, 1095, 1223],
        iconKey: 'ARM',
    },
    {
        categoryIds: [335, 40, 69, 457, 381, 690, 1259, 192, 329, 752, 509, 482],
        iconKey: 'AUS',
    },
    {
        categoryIds: [68, 144, 95, 101, 168, 266, 375, 1238],
        iconKey: 'AUT',
    },
    {
        categoryIds: [84, 395, 648, 361],
        iconKey: 'AZE',
    },
    {
        categoryIds: [729],
        iconKey: 'BHS',
    },
    {
        categoryIds: [837, 210, 886, 382, 794],
        iconKey: 'BHR',
    },
    {
        categoryIds: [360, 876, 453],
        iconKey: 'BGD',
    },
    {
        categoryIds: [706, 1033],
        iconKey: 'BRB',
    },
    {
        categoryIds: [265, 64, 553, 552, 578, 602, 1109, 346, 1185, 1189, 1201, 1202],
        iconKey: 'BLR',
    },
    {
        categoryIds: [149, 308, 117, 394, 993, 374, 1236],
        iconKey: 'BEL',
    },
    {
        categoryIds: [889],
        iconKey: 'BEN',
    },
    {
        categoryIds: [1060],
        iconKey: 'BTN',
    },
    {
        categoryIds: [114, 919],
        iconKey: 'BOL',
    },
    {
        categoryIds: [264, 807, 699, 662, 1486],
        iconKey: 'BIH',
    },
    {
        categoryIds: [769, 410],
        iconKey: 'BWA',
    },
    {
        categoryIds: [271, 107, 74, 112, 684, 1135, 663],
        iconKey: 'BRA',
    },
    {
        categoryIds: [485],
        iconKey: 'BRN',
    },
    {
        categoryIds: [307, 818, 313, 195, 1255, 724],
        iconKey: 'BGR',
    },
    {
        categoryIds: [1281],
        iconKey: 'BFA',
    },
    {
        categoryIds: [464, 957, 1184],
        iconKey: 'BDI',
    },
    {
        categoryIds: [704, 1564],
        iconKey: 'KHM',
    },
    {
        categoryIds: [199, 90, 812, 262, 1226],
        iconKey: 'CAN',
    },
    {
        categoryIds: [1212, 994, 263],
        iconKey: 'CMR',
    },
    {
        categoryIds: [1303],
        iconKey: 'CYM',
    },
    {
        categoryIds: [118, 143, 115, 160, 89, 65, 131, 1068, 1200],
        iconKey: 'CZE',
    },
    {
        categoryIds: [205, 1040, 1137],
        iconKey: 'CHALLENGER',
    },
    {
        categoryIds: [76, 448, 956],
        iconKey: 'CHL',
    },
    {
        categoryIds: [261, 454, 88, 339, 372, 930, 866, 1177, 857, 1070],
        iconKey: 'CHN',
    },
    {
        categoryIds: [556, 19, 456, 1340, 616, 1216],
        iconKey: 'CYP',
    },
    {
        categoryIds: [215, 1284, 412],
        iconKey: 'CIV',
    },
    {
        categoryIds: [801, 166, 398],
        iconKey: 'COL',
    },
    {
        categoryIds: [600, 1263],
        iconKey: 'COG',
    },
    {
        categoryIds: [365, 39, 409, 245, 323, 369, 326, 815],
        iconKey: 'KOR',
    },
    {
        categoryIds: [85, 1250, 949, 1382, 1498],
        iconKey: 'CRI',
    },
    {
        categoryIds: [334, 159, 178, 155, 109, 675, 344, 694, 1517, 1581],
        iconKey: 'HRV',
    },
    {
        categoryIds: [863],
        iconKey: 'CUW',
    },
    {
        categoryIds: [363, 869, 777, 686, 806, 1597],
        iconKey: 'CUB',
    },
    {
        categoryIds: [151],
        iconKey: 'DAV',
    },
    {
        categoryIds: [14],
        iconKey: 'FED',
    },
    {
        categoryIds: [81, 32, 46, 204, 59, 260, 134, 406],
        iconKey: 'DNK',
    },
    {
        categoryIds: [1453],
        iconKey: 'DJI',
    },
    {
        categoryIds: [1327, 1360],
        iconKey: 'DMA',
    },
    {
        categoryIds: [28, 1014, 888, 964, 836, 1663],
        iconKey: 'ARE',
    },
    {
        categoryIds: [70, 1264],
        iconKey: 'ECU',
    },
    {
        categoryIds: [50, 975, 979, 986],
        iconKey: 'EGY',
    },
    {
        categoryIds: [165, 1025, 1445],
        iconKey: 'SLV',
    },
    {
        categoryIds: [75, 105, 188, 311, 450, 184, 1213],
        iconKey: 'CHE',
    },
    {
        categoryIds: [259, 852, 461, 72, 819, 1008, 338, 1229],
        iconKey: 'EST',
    },
    {
        categoryIds: [463, 737],
        iconKey: 'ETH',
    },
    {
        categoryIds: [547, 297, 298, 387],
        iconKey: 'PHL',
    },
    {
        categoryIds: [10, 138, 71, 55, 52, 128, 38, 377, 981, 268, 1196, 1289, 698, 775],
        iconKey: 'FIN',
    },
    {
        categoryIds: [389, 1288],
        iconKey: 'FJI',
    },
    {
        categoryIds: [106, 181, 35, 104, 60, 442, 1301],
        iconKey: 'FRA',
    },
    {
        categoryIds: [258, 1632],
        iconKey: 'FRO',
    },
    {
        categoryIds: [879],
        iconKey: 'GMB',
    },
    {
        categoryIds: [228, 603, 554, 990],
        iconKey: 'GEO',
    },
    {
        categoryIds: [120, 157, 27, 21, 119, 18, 279, 305, 1210, 966, 1207, 1488],
        iconKey: 'DEU',
    },
    {
        categoryIds: [257],
        iconKey: 'GHA',
    },
    {
        categoryIds: [214],
        iconKey: 'GIB',
    },
    {
        categoryIds: [145, 8, 173, 20, 557, 1484, 1568],
        iconKey: 'GRC',
    },
    {
        categoryIds: [1256, 1348, 1365],
        iconKey: 'GRD',
    },
    {
        categoryIds: [824],
        iconKey: 'GUM',
    },
    {
        categoryIds: [100, 925, 817, 924, 1029],
        iconKey: 'GTM',
    },
    {
        categoryIds: [1274],
        iconKey: 'GIN',
    },
    {
        categoryIds: [751],
        iconKey: 'GUY',
    },
    {
        categoryIds: [796],
        iconKey: 'HTI',
    },
    {
        categoryIds: [86],
        iconKey: 'HND',
    },
    {
        categoryIds: [87, 738, 733, 472],
        iconKey: 'HKG',
    },
    {
        categoryIds: [23, 37],
        iconKey: 'ITF',
    },
    {
        categoryIds: [211, 354, 362, 792],
        iconKey: 'IND',
    },
    {
        categoryIds: [565, 212, 465, 1028, 1181, 1562],
        iconKey: 'IDN',
    },
    {
        categoryIds: [
            304, 58, 113, 318, 77, 170, 102, 273, 299, 73, 300, 163, 274, 15, 393, 302, 236, 317,
            270, 217, 36, 9, 31, 26, 169, 301, 337, 278, 239, 1150, 320, 473, 484, 524, 808, 934,
            917, 1243, 1244, 933, 1331, 1075, 1215, 269, 963, 987, 487, 1291, 1293, 1292, 1296,
            1295, 982, 938, 1269, 1294, 1061, 1487,
        ],
        iconKey: 'INT',
    },
    {
        categoryIds: [222, 856, 1228, 781, 821],
        iconKey: 'JOR',
    },
    {
        categoryIds: [649, 63, 580, 814, 539, 1551],
        iconKey: 'IRN',
    },
    {
        categoryIds: [1278, 920],
        iconKey: 'IRQ',
    },
    {
        categoryIds: [864, 776, 227, 708, 897, 906],
        iconKey: 'IRL',
    },
    {
        categoryIds: [147],
        iconKey: 'NIR',
    },
    {
        categoryIds: [256, 447, 443, 1246, 331, 1230, 1199],
        iconKey: 'ISL',
    },
    {
        categoryIds: [854, 142, 29, 185, 569, 1321],
        iconKey: 'ISR',
    },
    {
        categoryIds: [42, 171, 696, 43, 150, 56, 97, 277, 922, 1330, 380],
        iconKey: 'ITA',
    },
    {
        categoryIds: [306, 1480],
        iconKey: 'JAM',
    },
    {
        categoryIds: [94, 255, 452, 182, 276, 833],
        iconKey: 'JPN',
    },
    {
        categoryIds: [254, 545, 674, 845, 1261, 324],
        iconKey: 'KAZ',
    },
    {
        categoryIds: [295, 992, 913, 832],
        iconKey: 'KEN',
    },
    {
        categoryIds: [1273, 998, 1252],
        iconKey: 'KGZ',
    },
    {
        categoryIds: [779, 216, 352],
        iconKey: 'KWT',
    },
    {
        categoryIds: [535, 731],
        iconKey: 'KSW',
    },
    {
        categoryIds: [1225],
        iconKey: 'LAO',
    },
    {
        categoryIds: [822, 816, 213, 489, 628, 124, 353],
        iconKey: 'LVA',
    },
    {
        categoryIds: [350, 862, 810, 1493, 1589],
        iconKey: 'LBN',
    },
    {
        categoryIds: [1345],
        iconKey: 'LSO',
    },
    {
        categoryIds: [1004],
        iconKey: 'LBR',
    },
    {
        categoryIds: [253],
        iconKey: 'LIE',
    },
    {
        categoryIds: [608, 137, 825, 785, 252, 379],
        iconKey: 'LTU',
    },
    {
        categoryIds: [251, 1350],
        iconKey: 'LUX',
    },
    {
        categoryIds: [669, 186, 579, 909, 408, 373],
        iconKey: 'MKD',
    },
    {
        categoryIds: [1286],
        iconKey: 'MDG',
    },
    {
        categoryIds: [384, 1336],
        iconKey: 'MDV',
    },
    {
        categoryIds: [1247, 480, 755],
        iconKey: 'MLI',
    },
    {
        categoryIds: [748, 459],
        iconKey: 'MWI',
    },
    {
        categoryIds: [17, 1405],
        iconKey: 'MLT',
    },
    {
        categoryIds: [1005],
        iconKey: 'MRT',
    },
    {
        categoryIds: [1270],
        iconKey: 'MUS',
    },
    {
        categoryIds: [248, 915, 715, 1349],
        iconKey: 'MAR',
    },
    {
        categoryIds: [79, 5, 275, 1024],
        iconKey: 'MEX',
    },
    {
        categoryIds: [250, 692, 661, 895],
        iconKey: 'MDA',
    },
    {
        categoryIds: [1217, 1647, 1656, 1552],
        iconKey: 'MNG',
    },
    {
        categoryIds: [249, 891, 1009, 881, 1387],
        iconKey: 'MNE',
    },
    {
        categoryIds: [941],
        iconKey: 'MOZ',
    },
    {
        categoryIds: [540],
        iconKey: 'MMR',
    },
    {
        categoryIds: [531, 936, 868],
        iconKey: 'NAM',
    },
    {
        categoryIds: [732, 224, 397, 1232],
        iconKey: 'MYS',
    },
    {
        categoryIds: [544, 1298, 1066, 1149, 405, 1081],
        iconKey: 'NIC',
    },
    {
        categoryIds: [1302],
        iconKey: 'NER',
    },
    {
        categoryIds: [356],
        iconKey: 'NGA',
    },
    {
        categoryIds: [98, 194, 272, 783, 41, 123, 791, 367, 778],
        iconKey: 'NOR',
    },
    {
        categoryIds: [135, 718, 896, 321, 1357],
        iconKey: 'NZL',
    },
    {
        categoryIds: [127, 498, 158, 970, 1235],
        iconKey: 'NLD',
    },
    {
        categoryIds: [1015, 999],
        iconKey: 'NPL',
    },
    {
        categoryIds: [247],
        iconKey: 'OMN',
    },
    {
        categoryIds: [99, 404, 470],
        iconKey: 'PAK',
    },
    {
        categoryIds: [391, 357],
        iconKey: 'PSE',
    },
    {
        categoryIds: [303, 1385, 1380],
        iconKey: 'PAN',
    },
    {
        categoryIds: [220, 960, 950, 1333],
        iconKey: 'PRY',
    },
    {
        categoryIds: [590, 246, 700, 928],
        iconKey: 'PER',
    },
    {
        categoryIds: [121, 154, 25, 67, 187, 476, 1320, 1023, 478],
        iconKey: 'POL',
    },
    {
        categoryIds: [7, 310, 156, 208, 132, 1248, 726],
        iconKey: 'PRT',
    },
    {
        categoryIds: [721, 1400],
        iconKey: 'PRI',
    },
    {
        categoryIds: [695, 62, 351, 855, 359, 780, 997],
        iconKey: 'QAT',
    },
    {
        categoryIds: [841, 739, 743, 908],
        iconKey: 'DOM',
    },
    {
        categoryIds: [49, 153, 312, 664, 494, 319, 903, 341, 327, 479],
        iconKey: 'ROU',
    },
    {
        categoryIds: [
            82, 198, 136, 30, 720, 141, 146, 1, 392, 1064, 1056, 1038, 1224, 451, 1034, 1073,
        ],
        iconKey: 'RUS',
    },
    {
        categoryIds: [497, 861, 865, 348],
        iconKey: 'RWA',
    },
    {
        categoryIds: [627, 61, 92, 57, 241, 202, 713, 1268, 390, 716, 750, 872],
        iconKey: 'USA',
    },
    {
        categoryIds: [1214],
        iconKey: 'LCA',
    },
    {
        categoryIds: [1001],
        iconKey: 'KNA',
    },
    {
        categoryIds: [1344],
        iconKey: 'WSM',
    },
    {
        categoryIds: [175, 355],
        iconKey: 'SMR',
    },
    {
        categoryIds: [44],
        iconKey: 'SCO',
    },
    {
        categoryIds: [116, 914],
        iconKey: 'SEN',
    },
    {
        categoryIds: [203, 657, 174, 91, 223, 345, 316, 315],
        iconKey: 'SRB',
    },
    {
        categoryIds: [1421],
        iconKey: 'SYC',
    },
    {
        categoryIds: [656, 759, 622, 500, 767],
        iconKey: 'SYR',
    },
    {
        categoryIds: [93, 24, 176, 309, 200, 702, 1556, 1573],
        iconKey: 'SVK',
    },
    {
        categoryIds: [689, 180, 573, 605, 33, 197, 411, 1323],
        iconKey: 'SVN',
    },
    {
        categoryIds: [757, 225],
        iconKey: 'SGP',
    },
    {
        categoryIds: [1233, 1313],
        iconKey: 'SLB',
    },
    {
        categoryIds: [179, 172, 161, 48, 108, 486, 1512, 1560],
        iconKey: 'ESP',
    },
    {
        categoryIds: [830, 458],
        iconKey: 'LKA',
    },
    {
        categoryIds: [652, 766, 851, 441],
        iconKey: 'SDN',
    },
    {
        categoryIds: [4, 193, 103, 13, 11, 53, 244, 133, 1027, 1062, 325, 1204, 1105, 1048],
        iconKey: 'SWE',
    },
    {
        categoryIds: [878, 834, 491, 710, 368, 1162, 1067],
        iconKey: 'TWN',
    },
    {
        categoryIds: [1121, 1122, 1123, 1032, 514, 756],
        iconKey: 'TJK',
    },
    {
        categoryIds: [1143, 1126, 1197],
        iconKey: 'TKM',
    },
    {
        categoryIds: [560, 705, 243, 660, 1058, 1043, 1242],
        iconKey: 'THA',
    },
    {
        categoryIds: [396, 1260],
        iconKey: 'TZA',
    },
    {
        categoryIds: [140],
        iconKey: 'WAL',
    },
    {
        categoryIds: [744, 939],
        iconKey: 'TGO',
    },
    {
        categoryIds: [460, 764],
        iconKey: 'TTO',
    },
    {
        categoryIds: [681, 139, 829, 880],
        iconKey: 'TUN',
    },
    {
        categoryIds: [111, 129, 601, 66, 162, 336],
        iconKey: 'TUR',
    },
    {
        categoryIds: [400],
        iconKey: 'UFC',
    },
    {
        categoryIds: [572, 790, 34, 570, 201, 551, 1134, 1026, 347, 349, 1383],
        iconKey: 'UKR',
    },
    {
        categoryIds: [490, 342, 774, 932, 1409],
        iconKey: 'UGA',
    },
    {
        categoryIds: [196, 606, 496, 177, 563, 562, 164, 1285, 1240],
        iconKey: 'HUN',
    },
    {
        categoryIds: [242, 495, 703, 747],
        iconKey: 'URY',
    },
    {
        categoryIds: [240, 1253, 1482],
        iconKey: 'UZB',
    },
    {
        categoryIds: [1186],
        iconKey: 'VUT',
    },
    {
        categoryIds: [78, 499, 753, 714, 988],
        iconKey: 'VEN',
    },
    {
        categoryIds: [83, 386, 746, 741, 946, 782, 1140],
        iconKey: 'VNM',
    },
    {
        categoryIds: [2, 235],
        iconKey: 'WTA',
    },
    {
        categoryIds: [343],
        iconKey: 'YEM',
    },
    {
        categoryIds: [1347, 943, 364, 1219],
        iconKey: 'ZMB',
    },
    {
        categoryIds: [679, 483, 1334],
        iconKey: 'ZWE',
    },

    // Special cases
    {
        categoryIds: [1621],
        iconKey: 'VOI', // Voice romania
    },
    {
        categoryIds: [1006],
        iconKey: 'ZNZ',
    },
];
